// React
import React from "react";

// Material UI
import TableBody from "@mui/material/TableBody";
import EmailLogsRow from "./EmailLogsRow";

const EmailLogsBody = ({
  emailLogs,
  page,
  rowsPerPage,
  allCustomerData,
  setUpdatedData,
  setTrigger,
}) => {
  return (
    <TableBody>
      {allCustomerData && emailLogs ?
        (
          emailLogs
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((row, index) => {
              return (
                <EmailLogsRow
                  row={row}
                  index={index}
                  key={index}
                  allCustomerData={allCustomerData}
                  setUpdatedData={setUpdatedData}
                  setTrigger={setTrigger}
                />
              );
            })
        ) : null
      }
    </TableBody>
  );
};

export default EmailLogsBody;
